angular.module('rjmNg.api').factory 'Signups', [
  "$resource"
  "serviceUrl"
  (
    $resource
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      create: angular.extend {}, defaultParams,
        method: 'POST'
      status: angular.extend {}, defaultParams,
        method: 'GET'
        url: serviceUrl("/v3/signups/:id")

    signups = $resource serviceUrl("/v3/signups"), {}, actions

    create: (data) ->
      signups.create(data).$promise

    status: (id) ->
      signups.status({id: id}).$promise

]
